import React, { useEffect, useRef } from 'react';
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
  Polyline
} from 'react-google-maps';
import Card from '@mui/material/Card';
import dropPin from 'assets/images/dropPin.png';
import originPin from 'assets/images/originPin.png';
import pause from 'assets/images/pause.svg';

const GoogleMapDetails = ({ segments = [], driverPathDetails }) => {
  const mapRef = useRef(null);
  
  // Fit bounds function to mimic static map's auto-zoom
  const fitBounds = () => {
    const bounds = new window.google.maps.LatLngBounds();
    segments.forEach(segment => {
      if (segment && segment.length > 0) {
        segment.forEach(item => bounds.extend(item));
      }
    });
    if (segments.length > 0 && mapRef.current) {
      mapRef.current.fitBounds(bounds);
    }
  };
  
  useEffect(() => {
    fitBounds();
  }, [segments]);

  return (
    <Card variant="outlined">
      <div className='gMapCont'>
        <GoogleMap
          ref={mapRef}
          defaultZoom={10}
          center={segments.length > 0 && segments[0].length > 0 ? segments[0][0] : { lat: 0, lng: 0 }}
          options={{
            tilt: 0,  // Ensure the map is rendered in 2D
            zoomControl: false,  // Disable the zoom control UI
            streetViewControl: false,  // Disable the Street View control
            mapTypeControl: false,  // Disable the map type control
            fullscreenControl: false  // Disable the fullscreen control
          }}
        >
          {segments.map((segment, index) => (
            segment && segment.length > 0 && ( // Ensure the segment is defined and has at least one coordinate
              <React.Fragment key={index}>
                {/* Render Polyline for each segment */}
                {segment.length > 1 && (
                  <Polyline
                    path={segment}
                    options={{
                      strokeColor: index % 2 === 0 ? "#0F538D" : "#0F538D", // Alternate colors for each segment
                      strokeWeight: 6,
                      defaultVisible: false,
                    }}
                  />
                )}

                {/* Marker for Pickup Point on the first segment */}
                {index === 0 && segment.length > 0 && (
                  <Marker
                    icon={{
                      url: originPin,
                      scaledSize: new window.google.maps.Size(40, 40),
                      anchor: new window.google.maps.Point(20, 20),
                    }}
                    position={segment[0]}
                  />
                )}

                {/* Marker for Pause Point at the end of each segment except the last one */}
                {index < segments.length - 1 && segment.length > 0 && (
                  <Marker
                    icon={{
                      url: pause,
                      scaledSize: new window.google.maps.Size(30, 30),
                      anchor: new window.google.maps.Point(15, 15),
                    }}
                    position={segment[segment.length - 1]}
                  />
                )}

                {/* Marker for Drop-Off Point on the last segment */}
                {index === segments.length - 1 && segment.length > 1 && (
                  <Marker
                    icon={{
                      url: dropPin,
                      scaledSize: new window.google.maps.Size(40, 40),
                      anchor: new window.google.maps.Point(20, 20),
                    }}
                    position={segment[segment.length - 1]}
                  />
                )}
              </React.Fragment>
            )
          ))}
        </GoogleMap>
      </div>
    </Card>
  );
};

export default withScriptjs(
  withGoogleMap(
    GoogleMapDetails
  )
);
